export default 'https://tme.understood.org/assets/price_tag.ee735e65.glb'